import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import { BcCommon } from '@/plugins/common';
import { EBcDeviceType } from '@/classes/BcEnums';
let HospRecipel = class HospRecipel extends Vue {
    constructor() {
        super();
        this.exportForm = {
            menuVisible: false,
            deviceTypeGroup: null,
            year: '',
            deviceType: '',
            serial: '',
        };
        this.formValid = false;
        this.pageLoading = false;
        this.tableLoading = false;
        this.dataHandleLoading = false;
        this.menuDatePicker = {
            createVisible: false,
            visible: false,
            date: '',
            events: [],
        };
        this.menuDateRange = {
            visible: false,
            dateRange: [],
            events: [],
        };
        this.tableOptions = {
            visible: true,
            pageSize: 10,
            page: 1,
            total: 1,
            expanded: []
        };
        this.snackbar = new CBcSnackbar();
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            loading: false,
            detail: false,
            status: false,
        };
        this.searchOptions = {
            detector: '',
            date: '',
            dateRange: [],
            hospital: null,
            device: null,
            deviceType: null,
            deviceMode: null,
            quickly: '',
            hospitalName: '',
            hospitalInfo: null
        };
        this.listHospital = [];
        this.list = [];
        this.headers = [
            { text: '医院', align: 'center', width: 120, value: 'hospitalName' },
            { text: '设备类型', align: 'center', width: 120, value: 'deviceType' },
            { text: '设备编号', align: 'center', width: 100, value: 'deviceId' },
            { text: '设备机型', align: 'center', width: 100, value: 'deviceInfo.mode' },
            { text: '业务日期', align: 'center', width: 110, value: 'date' },
            { text: '业务总数', align: 'center', width: 100, value: 'total' },
            { text: '业务成功数', align: 'center', width: 110, value: 'success' },
            { text: '业务失败数', align: 'center', width: 110, value: 'fails' },
            { text: '配置瓶数(台式机)', align: 'center', width: 120, value: 'bottles' },
            { text: '配置成功率(台式机)', align: 'center', width: 110, value: 'rate' },
            { text: '配药时长(台式机)', align: 'center', width: 120, value: 'dspTime' },
            { text: '无故障时长(台式机)', align: 'center', width: 110, value: 'noErrorRunTime' },
            { text: '记录人', align: 'center', width: 110, value: 'recorder' },
            { text: '操作', align: 'center', width: 120, value: 'action', sortable: false, filterable: false }
        ];
        this.deviceSerialInfo = {}; // 设备信息,导出excel 过滤使用
        this.formDataMenu = {};
        this.formData = {};
        this.listDevice = [];
        this.formFields = {
            isShowBottles: true,
            isShowDspTime: true,
            isShowNoErrorRunTime: true,
            dateHint: '配置日期',
            totalHint: '配置总数',
            successHint: '配置成功数',
            failsHint: '配置失败数'
        }; // 表单提示信息配置，默认显示台式机的
        const that = this;
    }
    get recRecordCatalogReverse() {
        return (this.recRecordCatalog || []).reverse();
    }
    async mounted() {
        const that = this;
        await that.getDevices();
        await that.getHospitalList();
        that.getList();
        that.fetchRecRecordCatalog();
        // that.fetchDeviceModeCatalog().then((data:any) => {
        //   that.deviceSerialInfo = data || {};
        // })
    }
    deviceTextFilter(item, queryText, itemText) {
        const that = this;
        const reg = new RegExp(queryText);
        const match = (reg.test(item.name) || reg.test(item.type) || reg.test(item.deviceNo) || reg.test(item.deviceId) || reg.test(item.mode));
        return match ? itemText : null;
    }
    onExportFormMenuVisibleChg(visible) {
        if (!visible) {
            this.exportForm.deviceTypeGroup = null;
            this.exportForm.deviceType = '';
            this.exportForm.year = '';
            this.exportForm.serial = '';
        }
    }
    onSearchHospitalValueChange(nv, ov) {
        const that = this;
        // console.log('select of hospital:', nv)
    }
    selectDate(date) {
        const that = this;
        if (date.length >= 2) {
            that.menuDateRange.visible = false;
        }
    }
    formatDate(iDate) {
        const date = new Date(iDate).toISOString().substr(0, 10);
        if (!date)
            return null;
        const [year, month, day] = date.split('-');
        return `${year}-${month}-${day}`;
    }
    getDevices() {
        const that = this;
        that.axios.get('/api/device', { params: {} }).then((res) => {
            that.listDevice = res && res.data && res.data.result || [];
            return res;
        }).catch((e) => that.snackbar.error('设备信息获取出错,' + (e && (e.info || e.error || e.result))));
    }
    getHospitalList() {
        const that = this;
        try {
            const deviceType = /^undefined$|^null$|^\s?$/i.test(that.searchOptions.deviceType) ? null : that.searchOptions.deviceType;
            const mode = /^undefined$|^null$|^\s?$/i.test(that.searchOptions.deviceMode) ? null : that.searchOptions.deviceMode;
            const ret = that.axios.get('/api/hospital', {
                params: {
                    simple: false,
                    short: true,
                    deviceType: deviceType,
                    mode: mode,
                }
            }).then((res) => {
                that.listHospital = (res && res.data && res.data.result || []).sort((a, b) => b.deviceCount - a.deviceCount);
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    refresh() {
        const that = this;
        try {
            try {
                that.fetchRecRecordCatalog();
            }
            catch (e) { }
            that.getList();
        }
        catch (e) { }
    }
    async download() {
        const that = this;
        const daL = (that.searchOptions.dateRange || []).length ? that.searchOptions.dateRange : null;
        /** 按照王勃定义的表格返回 */
        const params = Object.assign({
            wbDefined: true,
            deviceType: that.searchOptions.deviceType,
            hospitalId: that.searchOptions.hospital && that.searchOptions.hospital.id,
            deviceId: that.searchOptions.device && [that.searchOptions.device.id],
            mode: that.searchOptions.deviceMode,
            date: that.searchOptions.date,
            recorder: that.searchOptions.detector,
        }, daL && daL.length == 2 ? { dateRange: JSON.stringify(daL) } : {}, daL && daL.length == 1 ? { date: daL[0] } : {});
        // console.log('donwload btn click: ', JSON.stringify(params))
        try {
            const result = await that.axios.post('/api/recipels/manual/export', params);
            if (result) {
                console.log('download result: ', JSON.stringify(result));
                if (!(result.data.data && result.data.path.length)) {
                    that.snackbar.warn('当前条件下没有可导出的数据');
                    return;
                }
                location.href = '/api/malfunctions/download?path=' + result.data.path;
            }
        }
        catch (e) {
            that.snackbar.error(`导出失败. ${(e && e.result) || ''}`);
        }
    }
    async getList() {
        const that = this;
        that.tableLoading = true;
        try {
            const daL = (that.searchOptions.dateRange || []).length ? that.searchOptions.dateRange : null;
            const pDt = that.searchOptions.deviceType;
            const pDetector = that.searchOptions.detector;
            const pDate = that.searchOptions.date;
            const dm = that.searchOptions.deviceMode;
            const hid = that.searchOptions.hospital && that.searchOptions.hospital.id;
            const de = that.searchOptions.device && [that.searchOptions.device.id];
            const ret = await that.axios.get('/api/recipels/manual', {
                params: Object.assign({
                    date: that.searchOptions.date,
                    limit: that.tableOptions.pageSize,
                    page: that.tableOptions.page,
                }, pDt ? { deviceType: pDt } : {}, hid ? { hospitalId: hid } : {}, de ? { deviceId: de } : {}, dm ? { mode: dm } : {}, pDate ? { date: pDate } : {}, pDetector ? { recorder: pDetector } : {}, daL && daL.length == 2 ? { dateRange: JSON.stringify(daL) } : {}, daL && daL.length == 1 ? { date: daL[0] } : {})
            }).then((res) => {
                that.list = (res && res.data && res.data.result || []).map((v) => {
                    const det = v.deviceInfo && v.deviceInfo.type;
                    v['deviceType'] = `${(det || '未知').replace(/台式|设备/g, '')}${det && '机'}`;
                    v['hospitalName'] = (v.hospitalInfo && v.hospitalInfo.name || '未关联');
                    return v;
                });
                that.tableOptions.total = res && res.data && res.data.sum || that.list.length;
                return res;
            });
            await that.getHospitalList();
            that.tableLoading = false;
            that.tableOptions.visible = false;
            return ret;
        }
        catch (e) {
            that.tableLoading = false;
            that.tableOptions.visible = false;
            that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    handleInputChange(value) {
        const that = this;
        if (that.deviceSerialList && that.deviceSerialList.length) {
            const serialList = this.deviceSerialList.filter(v => value ? new RegExp(v.type, 'i').test(value) : true);
            const serialCode = serialList.filter(v => v.serial == that.exportForm.serial);
            if (!serialCode || !serialCode.length) {
                this.exportForm.serial = ''; // 清空
            }
        }
    }
    async exportData(value) {
        const that = this;
        try {
            if (!value)
                value = that.exportForm.deviceType;
            const result = await that.axios.post('/api/recipels/manual/export', { deviceType: that.exportForm.deviceType, serial: that.exportForm.serial, year: new Date().format(that.exportForm.year) });
            if (result && result.data) {
                if (!result.data.data) {
                    that.snackbar.warn('当前条件下没有可导出的数据');
                    return;
                }
                location.href = '/api/recipels/manual/download?path=' + result.data.path;
            }
            that.exportForm.menuVisible = false;
        }
        catch (e) {
            console.log('export error:', e);
            that.snackbar.error(`导出失败. ${(e && e.result) || ''}`);
        }
    }
    getDeviceItem(id, key) {
        const that = this;
        const it = that.listDevice.find((v) => v.id === id);
        return it && it[key] || '';
    }
    getDeviceRate(item) {
        if (!item.deviceInfo)
            return '';
        // 这里根据设备类型获取设备类型
        const deviceType = BcCommon.getDeviceCategory(item.deviceInfo.type, item.deviceInfo.mode);
        if (deviceType == EBcDeviceType.Ampul
            || deviceType == EBcDeviceType.Xilin
            || deviceType == EBcDeviceType.Auto
            || deviceType == EBcDeviceType.Liquid
            || deviceType == EBcDeviceType.PreDissolve) {
            return Math.floor(item.rate * 100).toFixed(2) + '%';
        }
        return '';
    }
    createNew() {
        const that = this;
        that.dialog.detail = false;
        that.dialog.editor = 1;
        that.dialog.title = '新增设备记录';
        that.dialog.text = '';
        that.formData = { date: that.formatDate(new Date()), userId: that.userInfo.userId, recorder: that.userInfo.name };
        that.dialog.visible = true;
    }
    editItem(iItem, type) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.editFormPanels = [];
        that.dialog.editor = 2;
        that.dialog.detail = false;
        that.dialog.title = '修改配置记录';
        that.dialog.text = '';
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        // 编辑时触发设备发生变化事件
        that.deviceOnChange(that.formData.deviceId);
        that.dialog.visible = true;
    }
    deleteItem(iItem) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.dialog.editor = 3;
        that.dialog.detail = false;
        that.dialog.title = '配置记录删除';
        that.dialog.text = '是否删除当前故配置记录，删除后将移至配置记录回收站.';
        that.formValid = true;
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        that.dialog.visible = true;
    }
    batchEditItem(rowDataList) {
        if (!rowDataList || !rowDataList.length) {
            this.snackbar.warn('暂无操作数据');
            return;
        }
        const that = this;
        that.searchOptions.hospitalInfo = null;
        that.dialog.editor = 4;
        that.dialog.detail = false;
        that.dialog.title = '批量修改当前页的医院信息';
        that.dialog.text = '是否批量修改当前页的医院信息';
        that.dialog.visible = true;
    }
    async createNewHandle() {
        const that = this;
        const body = JSON.parse(JSON.stringify(that.formData));
        if (/object/i.test(typeof body['deviceId']))
            body['deviceId'] = body.deviceId.id;
        const ret = await that.axios.post('/api/recipels/manual', body);
        return ret;
    }
    editItemHandle() {
        const that = this;
        const hosInfo = that.formData.hospitalName;
        // 重组医院信息
        if (hosInfo !== null && typeof hosInfo === 'object') {
            // 删除不必要字段
            delete hosInfo.deletedAt;
            // delete hosInfo.devices;
            that.formData.hospitalId = hosInfo.id;
            that.formData.hospitalInfo = hosInfo;
            that.formData.hospitalName = hosInfo.name || '';
        }
        const form = JSON.parse(JSON.stringify(that.formData));
        const body = form;
        if (/object/i.test(typeof body['deviceId']))
            body['deviceId'] = body['deviceId'].id;
        return that.axios.put('/api/recipels/manual/' + that.formData.id, body);
    }
    deleteItemHandle() {
        const that = this;
        return that.axios.delete('/api/recipels/manual/' + that.formData.id, { data: { ...that.formData } });
    }
    async batchEditItemHandle() {
        const that = this;
        if (!that.list || !that.list.length) {
            that.snackbar.warn('暂无操作数据');
            return;
        }
        const hosInfo = that.searchOptions.hospitalInfo;
        // 重组医院信息
        if (hosInfo !== null && typeof hosInfo === 'object') {
            delete hosInfo.deletedAt;
            // delete hosInfo.devices;
            const promises = that.list.map(async (c) => {
                c.hospitalId = hosInfo.id;
                c.hospitalInfo = hosInfo;
                c.hospitalName = hosInfo.name || '';
                const form = JSON.parse(JSON.stringify(c));
                const body = form;
                if (/object/i.test(typeof body['deviceId']))
                    body['deviceId'] = body['deviceId'].id;
                return that.axios.put('/api/recipels/manual/' + c.id, body);
            });
            try {
                await Promise.all(promises);
                // 在这里可以执行接口全部调用完毕后的逻辑
            }
            catch (e) {
                // 处理错误
                that.snackbar.error('操作失败:', e && (e.info || e.error || e.errorInfo || e.result || e.toString()) || '');
            }
        }
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    async save() {
        const that = this;
        const typeName = (that.dialog.editor === 1 ? '新增' : that.dialog.editor === 2 ? '修改' : '删除') + '故障信息';
        that.dataHandleLoading = true;
        try {
            switch (that.dialog.editor) {
                case 1:
                    await that.createNewHandle();
                    break;
                case 2:
                    await that.editItemHandle();
                    break;
                case 3:
                    await that.deleteItemHandle();
                    break;
                case 4:
                    await that.batchEditItemHandle();
                    break;
                default:
                    break;
            }
            that.dataHandleLoading = false;
            that.dialog.visible = false;
            await that.getList();
            that.snackbar.success(`${that.dialog.editor === 4 ? '批量修改医院信息' : typeName}成功`);
        }
        catch (e) {
            console.log('handle result error:', e);
            that.dataHandleLoading = false;
            if (that.dialog.editor === 3)
                that.dialog.visible = false;
            that.snackbar.error(e && (e.info || e.error || e.errorInfo || e.result || e.toString()) || `${typeName}失败`);
        }
    }
    paginationHandle() {
        const that = this;
        const ps = Number.isNaN(parseInt(that.tableOptions.pageSize, 10)) ? that.tableOptions.total : that.tableOptions.pageSize;
        if (that.tableOptions.page > Math.ceil(that.tableOptions.total / ps))
            that.tableOptions.page = 1;
        that.getList();
    }
    // 监听设备选择
    deviceOnChange(data) {
        // 这里根据设备类型获取设备类型
        const deviceType = BcCommon.getDeviceCategory(data.type, data.mode);
        this.formFields.deviceType = deviceType;
        this.formFields.isShowBottles = false;
        this.formFields.isShowDspTime = false;
        this.formFields.isShowNoErrorRunTime = false;
        // 获取后根据设备类型展示设备记录字段描述
        switch (deviceType) {
            case EBcDeviceType.Ampul:
            case EBcDeviceType.Auto:
            case EBcDeviceType.Xilin:
            case EBcDeviceType.Liquid:
            case EBcDeviceType.Other:
            case EBcDeviceType.PreDissolve:
                if (deviceType == EBcDeviceType.Ampul || deviceType == EBcDeviceType.Xilin || deviceType == EBcDeviceType.Auto) {
                    this.formFields.isShowBottles = true;
                    this.formFields.isShowDspTime = true;
                    this.formFields.isShowNoErrorRunTime = true;
                }
                this.formFields.dateHint = '配置日期';
                this.formFields.totalHint = '配置总数';
                this.formFields.successHint = '配置成功数';
                this.formFields.failsHint = '配置失败数';
                break;
            case EBcDeviceType.BreathTrain:
                this.formFields.dateHint = '训练日期';
                this.formFields.totalHint = '训练总人数';
                this.formFields.successHint = '达标人数';
                this.formFields.failsHint = '未达标人数';
                this.formFields.isShowBottles = false;
                break;
            case EBcDeviceType.EndoscopeArk:
                this.formFields.dateHint = '存储日期';
                this.formFields.totalHint = '存取总数';
                this.formFields.successHint = '存入次数';
                this.formFields.failsHint = '取出次数';
                this.formFields.isShowBottles = false;
                break;
            case EBcDeviceType.CleaningMachine:
                this.formFields.dateHint = '清洗日期';
                this.formFields.totalHint = '清洗总数';
                this.formFields.successHint = '清洗成功数';
                this.formFields.failsHint = '清洗失败数';
                this.formFields.isShowBottles = false;
                break;
        }
    }
};
__decorate([
    Getter
], HospRecipel.prototype, "deviceSerialList", void 0);
__decorate([
    Getter
], HospRecipel.prototype, "userInfo", void 0);
__decorate([
    Getter
], HospRecipel.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], HospRecipel.prototype, "recRecordCatalog", void 0);
__decorate([
    Action
], HospRecipel.prototype, "fetchRecRecordCatalog", void 0);
__decorate([
    Action
], HospRecipel.prototype, "fetchDeviceModeCatalog", void 0);
__decorate([
    Watch('exportForm.menuVisible')
], HospRecipel.prototype, "onExportFormMenuVisibleChg", null);
__decorate([
    Watch('searchOptions.hospital')
], HospRecipel.prototype, "onSearchHospitalValueChange", null);
__decorate([
    Watch('tableOptions.pageSize'),
    Watch('tableOptions.page')
], HospRecipel.prototype, "paginationHandle", null);
HospRecipel = __decorate([
    Component({
        name: 'RecipelManualRecords',
        components: {
            BcSnackbar
        }
    })
], HospRecipel);
export default HospRecipel;
;
